<template>
    <div class="container">
        <div class="row">

            <div class="wizard-steps offset-xs-4 col-xs-4">
              <span class="step" v-bind:class="{ active: step==1, finish: step > 1 }"></span>
              <span class="step" v-bind:class="{ active: step==2, finish: step > 2 }"></span>
              <span class="step" v-bind:class="{ active: step==3, finish: step > 3 }"></span>
              <span class="step" v-bind:class="{ active: step==4, finish: step > 4 }"></span>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import 'bootstrap'

export default {
  name: "Steps",
  props: ['step']
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';

.wizard-steps {
    width: 100%;
    text-align: center;
}
.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #000;
  border: none;  
  border-radius: 50%;
  display: inline-block;
  opacity: 0.3;
}
.step.active {
  opacity: 1;
}
/* Mark the steps that are finished and valid: */
.step.finish {
  background-color: $corp-color;
  opacity: 1;
}
</style>